export default __webpack_public_path__ + "static/media/ananda.7ed79d61.jpg";